export type ShareResult = "shared" | "copied" | "cancelled";

interface ShareDevice {
  share?: (data: { url: string; title?: string }) => Promise<void>;
  clipboard?: { writeText: (text: string) => Promise<void> };
  /** A finger rather than a mouse, which is when the phone's share sheet is what people expect. */
  touch: boolean;
}

export function canShareSheet(device: ShareDevice): boolean {
  return device.touch && device.share !== undefined;
}

/** The phone's share sheet where there is one, otherwise the clipboard. */
export async function shareLink(
  url: string,
  title: string,
  device: ShareDevice,
): Promise<ShareResult> {
  if (canShareSheet(device)) {
    try {
      await device.share!({ url, title });
      return "shared";
    } catch (error) {
      if (error instanceof Error && error.name === "AbortError") {
        return "cancelled";
      }
    }
  }
  if (device.clipboard === undefined) {
    throw new Error("No way to share or copy here.");
  }
  await device.clipboard.writeText(url);
  return "copied";
}

export function browserShareDevice(): ShareDevice {
  return {
    ...(typeof navigator.share === "function" ? { share: (data) => navigator.share(data) } : {}),
    ...(navigator.clipboard === undefined ? {} : { clipboard: navigator.clipboard }),
    touch: window.matchMedia("(pointer: coarse)").matches,
  };
}
